/* This page takes in props and displays explanatory onformation for a particular page. There is a close button to get the
   component out of the way if desired. */

   import React, { useEffect, useState }        from "react";
   import {
   Box,
   Button,
   Grid,
   Typography }                                 from '@material-ui/core'
   import PropTypes                             from 'prop-types'

   const InfoComponent = ( { closeComponent, info } ) => {

      const [ displayInfo,                      setDisplayInfo ]  =  useState([])

      useEffect( () => {
         setDisplayInfo(
            info.map( (info, i) => {
               return(
                  <Grid key={i} >
                     <Typography align='left' style={{marginBottom: '0.5rem', marginLeft: '1rem'}} >
                        { info }
                     </Typography>
                  </Grid>
               )
            })
         )
      }, [] )


      return (
         <Box style={{ marginBottom: '1rem', marginTop: '6rem' }} >
            { displayInfo }
            <Grid item xs={2} style={{ marginTop: '1rem' }}>
               <Button variant='contained' color='primary' onClick={closeComponent} >Close</Button>
            </Grid>
         </Box>
      )
   }

InfoComponent.propTypes = {
   closeComponent:                              PropTypes.func,
   info:                                        PropTypes.array
}

export default InfoComponent